import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from '../../services/configuration/configuration.service';

@Pipe({
  name: 'groupType'
})
export class FieldTypePipe implements PipeTransform {
  constructor(private service: ConfigurationService) {}

  transform(fieldId: number): string {
    const item = this.service.fieldTypes.find((field) => field.id === fieldId);
    return item ? item.name : '';
  }
}
